import React, { useState, useEffect } from 'react'
import slaRepository from '../SlaRepository'
import { makeStyles } from '@material-ui/core/styles'
import * as R from 'ramda'
import {
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  YAxis,
  Bar,
  XAxis
} from 'recharts'
import { Paper, Grid, Typography } from '@material-ui/core'
import useQueryFilter from '../useQueryFilter'

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(2)
  }
}))

export default function ChartSolicitacoesTotal(props) {
  const classes = useStyles()
  const [data, setData] = useState([])
  const [criadas, setCriadas] = useState('')
  const [finalizadas, setFinalizadas] = useState('')
  const [query, periodo] = useQueryFilter(props.location.search)

  useEffect(() => {
    async function fetchData(query) {
      if (query.dataInicio && query.dataFim) {
        const [responseCriadas, responseFinalizadas] = await Promise.all([
          slaRepository.solicitacoesPorHora(
            query.dataInicio,
            query.dataFim,
            query.empresaId
          ),
          await slaRepository.solicitacoesFinalizadasPorHora(
            query.dataInicio,
            query.dataFim,
            query.empresaId
          )
        ])
        if (responseCriadas.ok && responseFinalizadas.ok) {
          const hours = R.union(
            Object.keys(responseCriadas.data),
            Object.keys(responseFinalizadas.data)
          ).sort()
          setCriadas(R.sum(Object.values(responseCriadas.data)))
          setFinalizadas(R.sum(Object.values(responseFinalizadas.data)))
          setData(
            hours.map(hour => ({
              hour: hour,
              criadas: responseCriadas.data[hour]
                ? parseFloat(responseCriadas.data[hour])
                : 0,
              finalizadas: responseFinalizadas.data[hour]
                ? parseFloat(responseFinalizadas.data[hour])
                : 0
            }))
          )
        }
      }
    }
    if (!R.isEmpty(query)) {
      fetchData(query)
    } else {
      setData([])
    }
  }, [query])

  return (
    <Grid item xs={12} lg={8} sm={12}>
      <Paper className={classes.card}>
        <Typography variant="h6">Solicitações por hora</Typography>
        <Typography variant="caption" display="block">
          Criadas: {criadas} - Finalizadas: {finalizadas}
        </Typography>
        <Typography variant="caption">{periodo}</Typography>
        <ResponsiveContainer height={300}>
          <BarChart
            data={data}
            margin={{
              top: 20
            }}
          >
            <YAxis interval={1} />
            <Tooltip />
            <Legend iconType="circle" />
            <Bar
              dataKey="criadas"
              name="Quantidade de solicitações criadas por hora"
              fill="#e57373"
              maxBarSize={30}
            />
            <Bar
              dataKey="finalizadas"
              name="Quantidade de solicitações finalizadas por hora"
              fill="#81c784"
              maxBarSize={30}
            />
            <XAxis dataKey="hour" tick={{ fontSize: 12 }} />
          </BarChart>
        </ResponsiveContainer>
      </Paper>
    </Grid>
  )
}
